import React, { createContext, useState } from 'react';
import { Form } from 'react-final-form';
import LoadingIndicator from './LoadingIndicator';

export const WizardPage: React.FC = ({ children }) => <div>{children}</div>;

type WizardProps = {
  onSubmit: (values: any) => void;
  submitting: boolean;
};

export const WizardContext = createContext<any>({});

// 3-steps form
const Wizard: React.FC<WizardProps> = ({ onSubmit, submitting, children }) => {
  const [page, setPage] = useState(0);
  const [formValues, setValues] = useState<any | undefined>(undefined);
  const activePage = React.Children.toArray(children)[page];
  const isLastPage = page === React.Children.count(children) - 1;

  // next page
  const next = (values: any) => {
    setPage(Math.min(page + 1, React.Children.count(children)));
    setValues(values);
  };

  // previous page
  const previous = () => {
    setPage(Math.max(page - 1, 0));
  };

  const handleSubmit = (values: any) => {
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values);
    } else {
      next(values);
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={formValues}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <WizardContext.Provider value={values}>{activePage}</WizardContext.Provider>
          <div className='d-flex flex-stack pt-15'>
            {page > 0 && (
              <button type='button' className='btn btn-lg btn-light-primary me-3' data-kt-stepper-action='previous' onClick={previous}>
                <i className='bi bi-arrow-left fw-700 fs-4'></i> Back
              </button>
            )}
            <button type='submit' disabled={submitting} className='btn btn-lg btn-primary me-3'>
              {submitting ? (
                <LoadingIndicator />
              ) : (
                <>
                  {!isLastPage && 'Next'} {isLastPage && 'Continue'}
                  <i className='bi bi-arrow-right fw-700 fs-4'></i>
                </>
              )}
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default Wizard;
